import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { apiSignIn, apiSignUp } from 'services/AuthService'
import { openNotification } from 'utils/notificate'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const res = await apiSignIn(values)
            if (res.data) {
                if (res.data.otp_required) {
                    navigate('/otp', { state: { userCredential: values } })
                    openNotification('success', res.data.message)
                    return {
                        status: 'success',
                        message: '',
                    }
                } else {
                    const data = res.data.data
                    const user = {
                        id: data.id,
                        name: data.name,
                        authority: [data.role],
                        email: data?.email,
                    }
                    const token = res.headers.authorization
                    localStorage.setItem(
                        'login_auth_token',
                        JSON.stringify(token)
                    )
                    localStorage.setItem('user_info', JSON.stringify(user))
                    dispatch(onSignInSuccess(token))
                    dispatch(setUser(user || null))
                    navigate(appConfig.authenticatedEntryPath)
                    navigate(appConfig.authenticatedEntryPath)
                    return {
                        status: 'success',
                        message: '',
                    }
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const res = await apiSignUp(values)
            if (res.data) {
                const { token } = res.data
                dispatch(onSignInSuccess(token))
                if (res.data.user) {
                    dispatch(setUser(res.data.user || null))
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = async() => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        localStorage.removeItem('user_info')
        localStorage.removeItem('login_auth_token')
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        // await apiSignOut()
       await handleSignOut()
       window.location.reload()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        signOut,
    }
}

export default useAuth
